import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexDataLabels,
  ApexFill,
  ApexTooltip,
  ApexLegend,
  ApexYAxis,
  ApexResponsive
} from 'ng-apexcharts';
import { FunilConversao } from '../interfaces/funil-conversao';

@Component({
  selector: 'app-fluxo-conversao',
  templateUrl: './fluxo-conversao.component.html',
  styleUrls: ['./fluxo-conversao.component.css']
})
export class FluxoConversaoComponent implements OnInit {

  public chartOptions: Partial<{
    series: ApexAxisChartSeries;
    chart: ApexChart;
    plotOptions: ApexPlotOptions;
    xaxis: ApexXAxis;
    dataLabels: ApexDataLabels;
    fill: ApexFill;
    tooltip: ApexTooltip;
    legend: ApexLegend;
    yaxis: ApexYAxis;
    responsive: ApexResponsive[]
  }>;

  @Input() dados: FunilConversao;

  constructor() { }

  ngOnInit(): void {
    this.inicializarGrafico();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dados'] && changes['dados'].currentValue) {
      this.inicializarGrafico();
    }
  }

  private inicializarGrafico(): void {
    const valores = this.dados.etapas.map(e => e.valor);
    const empurrar = valores.map(v => (this.dados.leadMax - v) / 2);
    const leadMax = this.dados.leadMax;
    const quantidadeCategorias = this.dados.etapas.length;

    this.chartOptions = {
      series: [
        { name: '', data: empurrar },
        { name: 'Valor', data: valores }
      ],
      chart: {
        type: 'bar',
        stacked: true,
        height: quantidadeCategorias * 40,
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '60%'
        }
      },
      xaxis: {
        categories: this.dados.etapas.map(e => e.label),
        max: this.dados.leadMax,
        tickAmount: 4,
      },
      fill: {
        colors: ['transparent', '#fbbf24']
      },
      tooltip: {
        shared: true,
        intersect: false,
        enabledOnSeries: [1], // Só habilita tooltip para a série "Valor"
        y: {
          formatter: function (val: number) {
            const percent = ((val / leadMax) * 100).toFixed(1);
            return `${val} (${percent}%)`;
          }
        },
        marker: {
          show: false
        },
        fixed: {
          enabled: true,
          position: 'bottomRight',
          offsetY: -17
        }
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
        style: {
          colors: ['#000000'] 
        },
        formatter: function (val: number) {
          return val.toString();
        }
      },
      legend: {
        show: false
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              height: quantidadeCategorias * 60
            },
            plotOptions: {
              bar: {
                horizontal: true,
                barHeight: '50%'
              }
            },
            xaxis: {
              tickAmount: 3,
              labels: {
                style: {
                  fontSize: '8px'
                }
              }
            },
            dataLabels: {
              style: {
                fontSize: '12px',
                colors: ['#000000'] // Mantém cor preta no responsive
              }
            }
          }
        }
      ]
    };
  }


}
